const InvoiceDestination = `
  id
  description
  updatedAt
`;

export default InvoiceDestination;
